import React from 'react';
import styled from '@emotion/styled';
import { formatExpiryDate } from '@move-frontend/form';
import {
	ITheme,
	StyledTextFieldErrorMessage,
	StyledTextFieldLabel,
} from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useFormatOnChange } from '../../../../../shared/form/useFormatOnChange';
import { useCreditCardFormContext } from '../helpers/useCreditCardFormContext';
import { StyledMicroformInputContainer } from './StyledMicroformInputContainer';
import themed from '../../../../../../ui/themer/themed';

const EXPIRY_DATE_ID = 'expiryDate';

// Because of microform we can not style the form input to our likings. Therefore, we also need to
// have an unstyled ExpiryDate component so that it wouldn't differ in style.
export const MicroformExpiryDate = () => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useCreditCardFormContext();
	const formatOnChange = useFormatOnChange(EXPIRY_DATE_ID, formatExpiryDate);

	const errorMessage =
		errors.expiryDate?.month?.message ?? errors.expiryDate?.year?.message;

	return (
		<>
			<StyledTextFieldLabel htmlFor={EXPIRY_DATE_ID}>
				{t('payment_form_expiry_date_label')}
			</StyledTextFieldLabel>
			<StyledMicroformInputContainer>
				<StyledInput
					id={EXPIRY_DATE_ID}
					type="text"
					placeholder={t('payment_form_expiry_date_placeholder')}
					maxLength={5}
					{...register(EXPIRY_DATE_ID, {
						onChange: formatOnChange,
					})}
				/>
			</StyledMicroformInputContainer>
			{errorMessage && (
				<StyledTextFieldErrorMessage role="alert">
					{errorMessage}
				</StyledTextFieldErrorMessage>
			)}
		</>
	);
};

const StyledInput = styled.input<{}, ITheme>`
	border: none;
	width: 100%;
	height: 40px;
	font-size: 16px;
	background-color: transparent;
	font-family: ${themed(({ typography }) => typography.body.fontFamily)};

	&:focus {
		outline: none;
	}
`;
